/* eslint-disable max-classes-per-file */
export class MethodNotFoundError extends Error {
  name = 'MethodNotFound';

  code = 'METHOD_NOT_FOUND';

  constructor(method: string) {
    super();
    this.message = `Unable to handle method: ${method}`;
  }
}

export class UninitailizedClientError extends Error {
  name = 'UninitailizedClient';

  code = 'UNINITIALIZED_CLIENT';

  message = 'Twilio client is not initialized';
}

export class TwilioError extends Error {
  name = 'TwilioError';

  code: string;

  constructor(code: string, message: string) {
    super();
    this.code = code;
    this.message = message;
  }
}
